import React from 'react';
import { useTranslation } from 'react-i18next';
import { ViewerControlTooltip } from "../../tooltip";
import { nsarchives } from "../../../../../i18n/namespaces";
import { ViewerControlFlag } from "../flag";
export const ViewerControlFlagDarkBackground = props => {
  const {
    t
  } = useTranslation(nsarchives.common);
  return /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: t('archive.view.controls.imageDark')
  }, /*#__PURE__*/React.createElement(ViewerControlFlag, props, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-brightness-6 font-size-16"
  })));
};